import { createComponent } from '@carvana/merch-components';

export const ToolTipWrapper = createComponent('span', {
  className:
    'relative inline-flex cursor-pointer focus-visible:outline focus-visible:outline-1 focus-visible:outline-[#228be6] focus-visible:outline-offset-0'
});
